import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../pages/Login/AuthContext.js";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useContext(AuthContext);

  // Поки триває мовчазне відновлення сесії після перезавантаження, нікуди
  // не редіректимо -- інакше кожен reload відкидав би користувача на /login.
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        Перевірка сесії...
      </div>
    );
  }

  if (!user) return <Navigate to="/login" />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/" />;

  return children;
};

export default ProtectedRoute;
